import React, { Component, Fragment } from "react";
import { Row, Card, CardTitle, Label, FormGroup, Button } from "reactstrap";
import { Colxx } from "../components/common/CustomBootstrap";

class UserLayout extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    document.body.classList.add("background");
    document.body.classList.add("no-footer");
  }
  componentWillUnmount() {
    document.body.classList.remove("background");
    document.body.classList.remove("no-footer");
  }

  render() {
    var back = (this.props.background)?"https://scripts.luminlogin.com/dash/dev/images/clients/heros/"+this.props.background:"https://scripts.luminlogin.com/dash/dev/images/app/login-background.png";
    return (
      <Fragment>
        <Row className="dashboard-full-height bg-white">
          <Colxx xxs="12">
            <Row className="dashboard-full-height">
              <Colxx xxs="12" sm="12" md="8" lg="6" xlg="4">
                <div className="loginWrapper">
        <main className="mainCenter">
          <div className="container">{this.props.children}</div>
        </main>
        </div>
              </Colxx>
              <Colxx xxs="2" sm="3" lg="6" md="4" xlg="8" className="login-right-col d-none d-sm-block">
                <div className="login-hero" style={{background:"url("+back+") no-repeat center right"}}>
                  
                </div>
              </Colxx>
            </Row>
          </Colxx>
        </Row>
       
      </Fragment>
    );
  }
}

export default UserLayout;
